import { useCallback } from "react";

import { ShareSkillCollectionSessionRow } from "./ShareSkillCollectionSessionRow";

import { SharedSessionsManageView } from "@/components/SharedSessions";
import type { SharedSession } from "@/queries/prompts";

interface ManageViewProps {
  workspaceId: number;
  collectionId: string;
  sessions: SharedSession[] | undefined;
  isLoadingSessions: boolean;
  onUpdate: (
    sessionId: string,
    fields: Partial<
      Pick<SharedSession, "name" | "is_public" | "remix_enabled" | "label_name" | "version_number">
    >,
  ) => void;
  onDelete: (sessionId: string) => void;
  onNewLink: () => void;
}

export const ManageView = ({
  workspaceId,
  collectionId,
  sessions,
  isLoadingSessions,
  onUpdate,
  onDelete,
  onNewLink,
}: ManageViewProps) => {
  const renderSessionRow = useCallback(
    (session: SharedSession, index: number) => (
      <ShareSkillCollectionSessionRow
        key={session.id}
        workspaceId={workspaceId}
        collectionId={collectionId}
        session={session}
        index={index}
        onUpdate={onUpdate}
        onDelete={onDelete}
      />
    ),
    [collectionId, onDelete, onUpdate, workspaceId],
  );

  return (
    <SharedSessionsManageView
      sessions={sessions}
      isLoadingSessions={isLoadingSessions}
      onNewLink={onNewLink}
      renderSessionRow={renderSessionRow}
    />
  );
};
